module.exports = __webpack_public_path__ + "static/media/add-one.4ad1e873.png";